<template>
  <div :data-clazz="model.clazz">
    <div class="panelTitle">{{ i18n['scriptTask'] }}</div>
    <div class="panelBody">
      <DefaultDetail :model="model" :on-change="onChange" :read-only="readOnly" />
      <div class="panelRow">
        <div>类型：</div>
        <a-select
          style="width:90%; font-size:12px"
          placeholder="选择任务类型"
          :disabled="readOnly"
          :value="model.taskType"
          @change="(e) => onChange('taskType', e)"
        >
          <a-select-option label="任务" value="task" />
          <a-select-option label="脚本" value="script" />
        </a-select>
      </div>
      <div v-if="model.taskType === 'script'" class="panelRow">
        <div>{{ i18n['scriptTask.script'] }}：</div>
        <a-textarea
          style="width:90%; font-size:12px"
          placeholder="输入脚本"
          :rows="4"
          :disabled="readOnly"
          :value="model.script"
          @input="(value) => {onChange('script', value)}"
        />
      </div>
      <div v-if="model.taskType === 'task'" class="panelRow">
        <div>任务：</div>
        <a-select
          style="width:90%; font-size:12px"
          placeholder="选择任务"
          :disabled="readOnly"
          :value="model.task"
          mode="multiple"
          :filterOption="true"
          @change="(e) => onChange('task', e)"
        >
          <a-select-option v-for="(taskValue, taskIndex) in tasks" :key="taskIndex" :title="taskValue.name" :value="taskValue.full_name" />
        </a-select>
      </div>
    </div>
  </div>
</template>
<script>
import DefaultDetail from './DefaultDetail'
export default {
  inject: ['i18n'],
  components: {
    DefaultDetail
  },
  props: {
    model: {
      type: Object,
      default: () => ({})
    },
    onChange: {
      type: Function,
      default: () => {}
    },
    tasks: {
      type: Array,
      default: () => ([])
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  }
}
</script>
